export const AppErrorMap = {
  somethingWentWrong: {
    code: 1,
    translationKey: 'error__something_went_wrong',
  },
  failedFetchingFeatureFlags: {
    code: 2,
    translationKey: 'error__something_went_wrong',
  },
  signupRequestFailed: {
    code: 3,
    translationKey: 'error__something_went_wrong',
  },
  failedMembershipBackendValidation: {
    code: 4,
    translationKey: 'error__something_went_wrong',
  },
  storeIdOrCountryMissing: {
    translationKey: 'error__missing_storeId_or_country',
  },
  applicationOffline: {
    translationKey: 'error__application_offline',
  },
};

export type AppErrorName = keyof typeof AppErrorMap;

export interface AppError {
  translationKey: string;
  code?: number;
}
